<ngx-json-ld [json]='{
    "@context": "http://schema.org",
    "@type": "WebPage",
    "name": "Contact",
    "description": "Heb je een vraag, idee, opmerking of iets anders voor ons? Dan horen we graag van je!"
}'></ngx-json-ld>

<div class="content-box content-box-responsive-single">
  <h1>Contact</h1>

  <p>Heb je een vraag, idee, opmerking of iets anders voor ons? Dan horen we graag van je!
    Je kunt ons emailen of een bericht sturen via onze sociale kanalen.</p>

  <a href="mailto:info@bruiloftinjebroekzak.nl" target="_blank">
    <fa-icon [icon]="['far', 'envelope']"></fa-icon></a>&nbsp;<a href="mailto:info@bruiloftinjebroekzak.nl" target="_blank">info&#64;bruiloftinjebroekzak.nl</a>

  <ul class="social-links">
    <li class="social-link-list-item">
      <a href="https://www.facebook.com/bruiloftinjebroekzak/" target="_blank">
        <fa-icon [icon]="['fab', 'facebook']"></fa-icon>
      </a>
    </li>

    <li class="social-link-list-item">
      <a href="https://www.instagram.com/bruiloftinjebroekzak/" target="_blank">
        <fa-icon [icon]="['fab', 'instagram']"></fa-icon>
      </a>
    </li>
  </ul>

  <h2>Bruiloft in je Broekzak</h2>
  <p class="business-info">
    <strong>KvK-nummer</strong>: 90612582<br>
    <strong>BTW-nummer</strong>: NL004832129B86<br>
    <strong>IBAN</strong>: NL13TRIO0788772570
  </p>
</div>
